/**Import react section */
import React from 'react'
import propTypes from 'prop-types'

/** Material UI import section */
import {
    Button,
} from '@material-ui/core';

import {ButtonCreateStyles} from '../../../resources/styles/ButtonCreateStyles'

const ButtonSaved =(props)=> {
    const {isSaving, onSavedClick, title} = props;
    const classes = ButtonCreateStyles();
    const onButtonSavedClick = (event)=>{
        if(onSavedClick){
            onSavedClick(event)
        }
    }

    return (
        <Button
            // color='secondary'
            variant="contained"
            disabled={isSaving}
            className={classes.btnSaved}
            onClick={onButtonSavedClick}
        >
            {title}
        </Button>
    )
}

ButtonSaved.propTypes = {
    /**Confirm the operation to be performed*/
    onSavedClick: propTypes.func.isRequired,
    /**Determinate if saving an operation */
    isSaving: propTypes.bool,
    /**Determinate el title of button */
    title: propTypes.string.isRequired,
}

ButtonSaved.defaultProps = {
    isSaving: false,
    title: '',
    onSavedClick: () =>
        console.warn('Callback [onSavedClick] no defined'),

}

export default ButtonSaved
